import { render, staticRenderFns } from "./MaintenanceTab.vue?vue&type=template&id=fc89198c"
import script from "./MaintenanceTab.js?vue&type=script&lang=js&external"
export * from "./MaintenanceTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports